{
  "form": {
    "editTitle": "Editează: {{name}}",
    "createTitle": "Creează un set nou de criterii",
    "nameLabel": "Nume criterii",
    "nameHelper": "Dați un nume descriptiv acestui set de criterii",
    "nameRequired": "Numele este obligatoriu",
    "priceRange": "Interval de preț (CHF)",
    "minPrice": "Preț minim",
    "maxPrice": "Preț maxim",
    "priceMaxError": "Prețul maxim trebuie să fie mai mare sau egal cu prețul minim",
    "sizeRange": "Suprafața proprietății (m²)",
    "minSize": "Suprafață minimă",
    "maxSize": "Suprafață maximă",
    "sizeMaxError": "Suprafața maximă trebuie să fie mai mare sau egală cu suprafața minimă",
    "roomsRange": "Număr de camere",
    "minRooms": "Camere minim",
    "maxRooms": "Camere maxim",
    "roomsMaxError": "Numărul maxim de camere trebuie să fie mai mare sau egal cu minimul",
    "priceNonNegative": "Prețul trebuie să fie pozitiv sau zero",
    "sizeNonNegative": "Suprafața trebuie să fie pozitivă sau zero",
    "roomsPositive": "Numărul de camere trebuie să fie pozitiv",
    "locationTitle": "Locație",
    "locationField": "Locație (separată prin virgule)",
    "locationHelper": "ex. Lausanne, Geneva, Vaud",
    "saving": "Se salvează...",
    "update": "Actualizează criteriile",
    "create": "Creează criteriile"
  },
  "list": {
    "emptyMessage": "Niciun set de criterii configurat încă. Creați unul pentru a începe să urmăriți proprietăți.",
    "createButton": "Creează set de criterii",
    "newButton": "Set nou de criterii",
    "count_one": "{{count}} set de criterii",
    "count_few": "{{count}} seturi de criterii",
    "count_other": "{{count}} de seturi de criterii",
    "active": "Activ",
    "inactive": "Inactiv",
    "noFilters": "Niciun filtru configurat",
    "any": "Oricare",
    "rooms": "camere",
    "updated": "Actualizat: {{date}}",
    "deleteTitle": "Șterge setul de criterii",
    "deleteConfirm": "Sigur doriți să dezactivați „{{name}}”? Acest set de criterii nu va mai fi folosit pentru potrivirea anunțurilor."
  },
  "display": {
    "title": "Criterii de căutare curente",
    "emptyMessage": "Niciun criteriu de căutare configurat încă. Folosiți formularul de mai jos pentru a seta preferințele.",
    "price": "Preț (CHF)",
    "size": "Suprafață (m²)",
    "rooms": "Camere",
    "location": "Locație",
    "any": "Oricare",
    "lastUpdated": "Ultima actualizare: {{date}}"
  },
  "page": {
    "title": "Configurare criterii de căutare",
    "description": "Gestionați seturile de criterii de filtrare pentru căutările de proprietăți. Fiecare set definește o combinație de filtre de preț, suprafață, camere și locație.",
    "updated": "Criterii actualizate cu succes!",
    "created": "Criterii create cu succes!",
    "deactivated": "Setul de criterii a fost dezactivat."
  }
}
